import React from 'react';
import FlatButton from "material-ui/FlatButton";
import Dialog from 'material-ui/Dialog';

export default class ConfirmDeletionDialog extends React.Component {
    render() {
        const actions = [
            <FlatButton
                label="Cancelar"
                onClick={this.props.handleClose}
            />,
            <FlatButton
                label="Confirmar"
                primary={true}
                onClick={this.props.handleConfirm}
            />
        ];

        return (
            <Dialog
                title="Confirma a remoção da tarefa?"
                actions={actions}
                modal={false}
                open={this.props.open}
                onRequestClose={this.props.handleClose}
                >
                <p>Atenção, esta operação é irreversível.</p>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/view/scheduler/job/ConfirmDeletionDialog.js